export default {
    url: '/home',
    template: `
        <home
            employees="vm.employees"
            company-statistics="vm.companyStatistics"
            sites="vm.sites"
            classifiers="vm.classifiers"
        />
    `,
    resolve: {
        employees (UserResource, TokenService, ROLE_CODE_ENUM) {
            return UserResource.getUsers({}, {
                siteIds: TokenService.getActiveSiteId(),
                roleCode: ROLE_CODE_ENUM.KEYS.EMPLOYEE
            }).$promise;
        },
        // we insert bootstrap as dependecy because bootstrap resolve initializes siteservice variables
        companyStatistics (bootstrap, CompanyResource) {
            return CompanyResource.statistics().$promise;
        },
        sites (SiteResource) {
            return SiteResource.query({ pageSize: 0, planningSites: true }).$promise;
        },
        classifiers (ClassifierResource) {
            return ClassifierResource.query({ pageSize: 0, expand: 'activeI18n' }).$promise;
        }
    },
    controller (employees, companyStatistics, sites, classifiers) {
        this.employees = employees;
        this.companyStatistics = companyStatistics;
        this.sites = sites;
        this.classifiers = classifiers;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/home/index.js